import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntSortIconComponent } from "./int-sort-icon.component";


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntSortIconComponent
  ],
  exports: [
    IntSortIconComponent
  ]
})
export class IntSortIconModule { }
